import { render, staticRenderFns } from "./Noticia.vue?vue&type=template&id=f0adc9ce&scoped=true&"
import script from "./Noticia.vue?vue&type=script&lang=js&"
export * from "./Noticia.vue?vue&type=script&lang=js&"
import style0 from "./Noticia.vue?vue&type=style&index=0&id=f0adc9ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0adc9ce",
  null
  
)

export default component.exports